import * as React from "react";
import type { SVGProps } from "react";
const SvgLayers01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 6.925 21.6 12 12 17.075 2.4 12z"
    />
  </svg>
);
export default SvgLayers01;
